<template>
  <div class="m-w">
    <div style="margin-top: 200px;"></div>
    <editor :api-key="apiKey" :init="tinyMceInit">

    </editor>
    <div style="margin-bottom: 100px;"></div>
  </div>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue';

  export default {
    components: {
      'editor': Editor
    },
    data() {
      return {
        apiKey: '14m86x5z1kuudomezuomzfl55t582jv71lqfr1cjiqlvpesj',
        tinyMceInit: {
          language: 'zh_CN'
        }
      }
    },
    methods:{

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/NewsEditor/index.vue